import { LanguageService } from 'src/app/shared/services/language.service';

import { GetLocaleFromLangPipe } from 'src/app/pipes/get-locale-from-lang.pipe';

import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDivider } from '@angular/material/list';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [CommonModule, MatCardModule, TranslateModule];
export const COMPONENTS = [FaIconComponent];
export const PIPES = [GetLocaleFromLangPipe];

@Component({
  selector: 'app-m6-forecast',
  templateUrl: './m6-forecast.component.html',
  styleUrls: ['./m6-forecast.component.scss'],
  imports: [...MODULES, ...COMPONENTS, ...PIPES, MatDivider],
})
export class M6ForecastComponent {
  public languageService = inject(LanguageService);

  text = input<string>();
  date = input<string>();
  imageUrl = input<string>();
  id = input<number>();
}
